import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Section, SectionHeader } from "./_helpers";
import { Globe, Palette, Check } from "lucide-react";
import api from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "sonner";

const LANGUAGES = [
  { code: "no", label_no: "Bokmål",   label_en: "Norwegian (Bokmål)", flag: "🇳🇴" },
  { code: "sv", label_no: "Svensk",   label_en: "Swedish",            flag: "🇸🇪" },
  { code: "da", label_no: "Dansk",    label_en: "Danish",             flag: "🇩🇰" },
  { code: "en", label_no: "Engelsk",  label_en: "English",            flag: "🇬🇧" },
];

export default function SprakPage() {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const isEn = i18n.language === "en";

  const setLanguage = async (code) => {
    i18n.changeLanguage(code);
    try { localStorage.setItem("ui_language", code); } catch {}
    if (user && user !== false) {
      try {
        await api.put("/me/ui-language", { ui_language: code });
      } catch (e) { /* not critical */ }
    }
    toast.success(t("sprak.changed_to", { lang: code.toUpperCase() }));
  };

  return (
    <>
      <Section testId="lang-section">
        <SectionHeader
          icon={Globe}
          title={t("sprak.title")}
          desc={t("sprak.desc")}
        />
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="lang-grid">
          {LANGUAGES.map((l) => {
            const active = i18n.language === l.code;
            return (
              <button
                key={l.code}
                onClick={() => setLanguage(l.code)}
                data-testid={`lang-option-${l.code}`}
                className={`relative p-4 text-left border transition-all ${
                  active
                    ? "border-[var(--magenta)] bg-[var(--magenta)]/[0.08]"
                    : "border-white/10 hover:border-white/30"
                }`}
              >
                <div className="text-2xl mb-2">{l.flag}</div>
                <div className="font-fraunces italic text-lg text-[var(--cream)]">
                  {isEn ? l.label_en : l.label_no}
                </div>
                <div className="font-meta text-[10px] mt-1">{l.code.toUpperCase()}</div>
                {active && (
                  <span className="absolute top-2 right-2 text-[var(--magenta)]"><Check className="h-4 w-4" /></span>
                )}
              </button>
            );
          })}
        </div>
        <p className="font-meta text-[10px] text-[var(--cream-faint)] mt-4 max-w-md leading-relaxed">
          {t("sprak.scope_note")}
        </p>
      </Section>

      <Section testId="theme-section">
        <SectionHeader icon={Palette} title={t("sprak.theme_title")} desc={t("sprak.theme_desc")} />
        <div className="grid grid-cols-3 gap-3 max-w-md">
          <div className="aspect-square bg-[var(--noir)] border-2 border-[var(--magenta)] flex items-end p-2 font-meta text-[var(--cream)]">
            Editorial Noir <span className="ml-1 text-emerald-400">✓</span>
          </div>
          <div className="aspect-square bg-[var(--noir-elev)] border border-white/10 flex items-end p-2 font-meta text-[var(--cream-faint)]">
            {t("sprak.coming")}
          </div>
          <div className="aspect-square bg-[var(--noir-elev)] border border-white/10 flex items-end p-2 font-meta text-[var(--cream-faint)]">
            {t("sprak.coming")}
          </div>
        </div>
      </Section>
    </>
  );
}
